import { cloneDeep } from 'lodash';
import { AnyAction } from 'redux';
import { GrievanceModel } from '../models/grievanceModel';
import actionTypes from '../types/grievanceTypes';

const defaultInitialState: GrievanceModel = {
  selectedClaimsList: null,
  currentlyEnabledPayer: '',
};

const initialState = cloneDeep(defaultInitialState);

const getCurrentEnabledPayer = ({ payload }: AnyAction): any => {
  if (Object.keys(payload || {})?.length) {
    const listOfHospActions = Object.keys(payload);
    const lastSelected = payload[listOfHospActions[listOfHospActions?.length - 1]];
    return `${lastSelected.payerId}${lastSelected?.productCode || ''}`;
  } else {
    return '';
  }
};

const grievanceReducer = (state: any = initialState, action: AnyAction): any => {
  switch (action.type) {
    case actionTypes.SET_SELECTED_CLAIMS:
      return {
        ...state,
        selectedClaimsList: action.payload,
        currentlyEnabledPayer: getCurrentEnabledPayer(action),
      };
    case actionTypes.RESET_GRIEVANCE:
      return defaultInitialState;
    case actionTypes.SEARCH_CLAIM_LIST:
      return {
        ...state,
        isSearchClickedList: state.isSearchClickedList + 1,
      };
    case actionTypes.SET_PAGE_INDEX_LIST:
      return {
        ...state,
        pageIndex: action.payload,
      };
    default: return state;
  }
};

export default grievanceReducer;
